<template>
  <el-dialog
    v-model="modalVisible"
    @close="closeModal"
    @open="openModal"
    :destroy-on-close="true"
    :append-to-body="true"
  >
    <div>
      <img style="width: 100%;" class="user_image" width="100%" :src="file" />
    </div>
  </el-dialog>
</template>

<script>
import { ref, inject, computed } from "vue";

export default {
  props: {
    modalName: {
      type: String,
    },
    options: {
      type: Object,
    },
  },
  setup(props) {
    console.log("🚀 ~ setup ~ props:", props)
    const $mitt = inject("$mitt");
    const modalVisible = ref(false);

    const closeModal = () => {
      modalVisible.value = false;
    };

    const file = computed(() => {
      return props.options.file.url;
    });
    $mitt.on(props.modalName, (options) => {
      modalVisible.value = options.show;
    });
    const openModal = () => {};
    return {
      closeModal,
      file,
      modalVisible,
      openModal,
    };
  },
};
</script>
